import { render, staticRenderFns } from "./reviewRejectCard.vue?vue&type=template&id=58868497&scoped=true"
import script from "./reviewRejectCard.vue?vue&type=script&lang=js"
export * from "./reviewRejectCard.vue?vue&type=script&lang=js"
import style0 from "./reviewRejectCard.vue?vue&type=style&index=0&id=58868497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58868497",
  null
  
)

export default component.exports